<template>
    <div>
        <h3>
            협치은평
            <div class="play_wrap">
                <span style="cursor: pointer;"
                    :class="isPlaySwiper ? 'stop' : 'play'"
                    @click.prevent="toggleSwiper"></span>
            </div>
        </h3>
        <div>
            <div class="ep-box02-wrap">
                <div>
                <swiper class="swiper" ref="swiper" :options="swiperOption" data-swiper-autoplay="2000">
                    <swiper-slide v-for="(governanceData, i) in governanceDatas" :key="i">
                        <div class="ep-box02" style="100%">
                            <a href="#" @click.prevent="selectGovernanceData(governanceData)">
                                <div class="label skyblue2" v-html="governanceData.bizNm"></div>
                                <div class="con" v-html="governanceData.summary"></div>
                            </a>
                        </div>
                    </swiper-slide>
                    <div class="swiper-button-prev" id="prev2" slot="button-prev"></div>
                    <div class="swiper-button-next" id="next2" slot="button-next"></div>
                </swiper>
                </div>
                 <div class="sort-box">
                    <a v-for="governanceCategory in governanceCategoryList" :key="governanceCategory.commonCode" :class="governanceCategory.commonCode === selectedGovernanceCategoryCode ? 'active' : ''" @click.prevent="selectGovernanceCategoryHandle(governanceCategory.commonCode)" href="#">{{ governanceCategory.commonCodeNm }}</a>
                </div>
            </div>
        </div>
        <transition name="modal">
            <GovernanceFoundInfoWin v-if="isShowGovernanceFoundInfoWin" :param-obj="paramObj" @close-governance-info-win="showGovernanceFoundInfoWin(false)" />
        </transition>
        <transition name="modal">
            <GovernanceInnoInfoWin v-if="isShowGovernanceInnoInfoWin" :param-obj="paramObj" @close-governance-info-win="showGovernanceInnoInfoWin(false)" />
        </transition>
    </div>
</template>

<script>
import { $WC } from '@/conf/common.const.js';
import GovernanceFoundInfoWin from '@/views/biz/GovernanceFoundInfoWin.vue';
import GovernanceInnoInfoWin from '@/views/biz/GovernanceInnoInfoWin.vue';

export default {
    name: 'governanceCard',
    data() {
        return {
            isPlaySwiper: true,
            swiperOption: {
                slidesPerView: 6,
                spaceBetween: 30,
                autoplay: {
                    delay: $WC.FIVE_SEC_INTERVAL,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '#next2',
                    prevEl: '#prev2'
                },
                breakpoints: {
                    1020: {
                    slidesPerView: 6,
                    spaceBetween: 30
                    },
                    768: {
                    slidesPerView: 4,
                    spaceBetween: 30
                    },
                    480: {
                    slidesPerView: 2,
                    spaceBetween: 30
                    }
                }
            },
            selectedGovernanceCategoryCode: "governance_found",
            governanceDatas: [],
            isShowGovernanceFoundInfoWin: false,
            isShowGovernanceInnoInfoWin: false,
            paramObj: {
                dataKdSqno: '',
                dataSqno: ''
            },
        }
    },
    computed: {
        governanceCategoryList() {
            return this.$store.getters.getGovernanceCategoryList.reverse();
        },
        governanceDataMap() {
            return this.$store.getters.getGovernanceDataMap;
        },
        metaInfo() {
            return {
                governance_found: {
                    bizNmProp: 'val2',
                    summaryProp: 'val7',
                    addrProp: '',
                    detailUrl: $WC.cp + 'ep/biz/governance_found/'
                },
                governance_inno: {
                    bizNmProp: 'val2',
                    summaryProp: 'val8',
                    addrProp: '',
                    detailUrl: $WC.cp + 'ep/biz/governance_inno/'
                }
            };
        }
    },
    created() {
        // 협치사업 분류코드 목록
        this.$store.dispatch('FETCH_GOVERNANCE_CATEGORY_LIST');

        // 협치사업 목록
        this.$store.dispatch('FETCH_GOVERNANCE_DATA_LIST')
            .then(() => {
                this.setGovernanceDatas();
            });

    },
    methods: {
        selectGovernanceCategoryHandle(governanceCategoryCode) {
            this.selectedGovernanceCategoryCode = governanceCategoryCode;
            this.setGovernanceDatas();
        },
        setGovernanceDatas() {
            let governanceCategoryCode = this.selectedGovernanceCategoryCode;

            let meta = this.metaInfo[governanceCategoryCode];
            let dataList = this.governanceDataMap[governanceCategoryCode];
            let governanceDatas = [];

            dataList.forEach((data) => {
                let governanceData = {
                    bizNm: data[meta.bizNmProp],
                    summary: data[meta.summaryProp],
                    detailUrl: meta.detailUrl,
                    dataKdSqno: data.dataKdSqno,
                    seq: data.amnDataSqno
                }
                governanceDatas.push(governanceData);
            });

            this.governanceDatas = governanceDatas;
        },
        showGovernanceFoundInfoWin(isShow) {
            this.isShowGovernanceFoundInfoWin = isShow;
        },
        showGovernanceInnoInfoWin(isShow) {
            this.isShowGovernanceInnoInfoWin = isShow;
        },
        selectGovernanceData(governance) {
            this.paramObj.dataKdSqno = governance.dataKdSqno;
            this.paramObj.dataSqno = governance.seq;
            if(this.selectedGovernanceCategoryCode  === 'governance_found') {
                this.showGovernanceFoundInfoWin(true);
            } else {
                this.showGovernanceInnoInfoWin(true);
            }
            return this.paramObj;
        },
        toggleSwiper() {
            if(this.isPlaySwiper) {
                // swiper 멈춤
                this.$refs.swiper.$swiper.autoplay.stop();
            } else {
                // swiper 시작
                this.$refs.swiper.$swiper.autoplay.start();
            }

            this.isPlaySwiper = !this.isPlaySwiper;
        }
    },
    components: {
        GovernanceFoundInfoWin,
        GovernanceInnoInfoWin
    }
}
</script>

<style scoped>

</style>
